import { Injectable } from "@angular/core";
import { VehicleCustomerMappingModel } from "../business-entities/Customer-detail.model";
import { GenericResponse } from "../business-entities/generic-response";
import { VehicleListViewModel, VehicleModel } from '../business-entities/vehicle-list-view-model';
import { VehicleListRequestModel } from '../business-entities/vehicleList-request-model';
import { VehicleDataService } from '../data-services/vehicle-data.service';

@Injectable({
  providedIn: 'root'
})

export class VehicleBusinessService {

  vehicleList: any;
  vehicleId: number;
  customerId: number;
  customerNo: string;
  customerName: string;
  contactUniqueId: string;
  crmCustomerObj: any;
  licensePlate: string;
  make: string;
  model: string;
  vinNo:string;
  contactId:string; //Customer Guid 
  vehicleGuid:string; //Vehicle Guid 
  selectedTab:any;
  existingCustomerNo:any;
  searchThroughLocalDF:boolean = false;
  customerRelationType:any = null;
  vehicleListRequest: VehicleListRequestModel =
        {
            searchTerm: '',
            startRecordNumber: 0,
            pageSize: 10,
            sortColumn: '',
            sortDirection: '',
            isForDocuments: false,
            licensePlate: '',
            companyMakeName: null,
            registrationDate: '',
            color: '',
            year: null,
            chassisNo: '',
            fuelType: null,
            sourceOfCreation: null,
            vehicleType: null,
            vehicleGroup: null,
            transmission: null,
            syncId: 0,
            isdeleted:false
        }
  constructor(private vehicleDataService: VehicleDataService) {
  }

  async getVehicleList(vehicleRequestModel: any) {
    await this.vehicleDataService
      .getVehicleList(vehicleRequestModel)
      .then(
        (res: any) => {
          this.vehicleList = res.responseObject;
        }
      );
    return this.vehicleList;
  }

  getVehicleById(id: number) {
    return this.vehicleDataService.getVehicleById(id);
  }
  editVehicle(model: VehicleListViewModel) {
    return this.vehicleDataService.editVehicle(model);
  }

  getVehicleByLicencePlateNo(licensePlate: string) {
    return this.vehicleDataService.getVehicleByLicencePlateNo(licensePlate);
  }

  async GetVehicleOwnerTypeDropdownList(): Promise<any> {
    return this.vehicleDataService.GetVehicleOwnerTypeDropdownList();
  }
  async GetVehicleTransmissionDropdownList(): Promise<any> {
    return this.vehicleDataService.GetVehicleTransmissionDropdownList();
  }

  async AddEditVehicle(vehicleInfo: VehicleModel): Promise<any> {
    return this.vehicleDataService.AddEditVehicle(vehicleInfo);
  }

  async crmAddEditVehicle(vehicleInfo: any): Promise<any> {
    return this.vehicleDataService.crmAddEditVehicle(vehicleInfo);
  }

  async getVehicleByCustomerId(customerId: number, customerGuid: string = null, isToFetchLocalOnly: boolean = false) {
    return this.vehicleDataService.getVehicleByCustomerId(customerId, customerGuid, isToFetchLocalOnly);
  }

  async UnmapCustomerVehicle(vehicleRequestModel: any): Promise<any> {
    return this.vehicleDataService.UnmapCustomerVehicle(vehicleRequestModel);
  }

  getCustomerDetailByVehicleId(id: number) {
    return this.vehicleDataService.getCustomerDetailByVehicleId(id);
  }

  async updateVehicleCustomerMapping(vehicleCustomerMapping: VehicleCustomerMappingModel): Promise<any> {
    return this.vehicleDataService.updateVehicleCustomerMapping(vehicleCustomerMapping);
  }

  async ResyncVehicle(licensePlate: string, moduleId: number) {
    return this.vehicleDataService.ResyncVehicle(licensePlate, moduleId);
  }

  async getVehicleFrmoDataFactoryByLicencePlateNo(licensePlate: string) {
    return this.vehicleDataService.getVehicleFrmoDataFactoryByLicencePlateNo(licensePlate);
  }
  
  GetVehicleOwnershipHistory(vehicleOwnershipRequestModel:any){
    return this.vehicleDataService.GetVehicleOwnershipHistory(vehicleOwnershipRequestModel);
  }
  async HardDeleteVehicle(model:any): Promise<GenericResponse<any>> {
    return  this.vehicleDataService.HardDeleteVehicle(model);
  }
  async DeleteVehicle(model:any): Promise<GenericResponse<any>> {
    return  this.vehicleDataService.DeleteVehicle(model);
  }

  async SearchCustomerThroughDF(model:any) : Promise<GenericResponse<any>>{
    return this.vehicleDataService.SearchCustomerThroughDF(model);
  }
}
